import useServiceData from './useServiceData'
import { gamesTutorial } from '../constants/copyright'
import { useContent } from '../redux/reducer/content'
import { useModal } from './useModal'
import { conturs, defaultContur, useTranslation } from '../translations'
import { isAlfaGameActive } from '../utils/game/isAlfaGameActive'

const shouldShowRulesModal = (gameState) => {
  if (gameState === 'platform') {
    return defaultContur !== conturs.me && isAlfaGameActive()
  }

  return false
}

const getRulesModalKeyData = (gameState) => {
  const currentData = new Date().toLocaleDateString().split('.').join('')
  const prefix = `${gameState}RulesModal`

  return { prefix, rulesKey: `${prefix}${currentData}` }
}

const getModalsDataWithoutRules = (modalsData, prefix) => {
  const newModalsData = {}

  for (const key in modalsData) {
    if (key.startsWith(prefix)) {
      continue
    }

    newModalsData[key] = modalsData[key]
  }

  return newModalsData
}

export const useGameRules = () => {
  const { get, save } = useServiceData()
  const { addModal } = useModal()
  const { state } = useContent()
  const { t } = useTranslation()

  const rulesModalCallback = (callback) => {
    if (!shouldShowRulesModal(state)) {
      callback?.()

      return
    }

    const modalsData = get('modalsData') || {}
    const { prefix, rulesKey } = getRulesModalKeyData(state)

    if (modalsData?.[rulesKey]) {
      callback?.()

      return
    }

    const newModalsData = getModalsDataWithoutRules(modalsData, prefix)

    save('modalsData', { ...newModalsData, [rulesKey]: true })

    addModal({
      type: 'startGameModal',
      props: {
        ...gamesTutorial[state],
        title: t(gamesTutorial[state]?.title),
        text: t(gamesTutorial[state]?.text),
        buttonText: t(gamesTutorial[state]?.buttonText),
        onClose: callback,
      },
    })
  }

  return { rulesModalCallback }
}
